<template>
    <v-dialog eager @input="change" value="true" persistent :max-width="maxWidth" @keydown.esc="choose(false)">
        <v-card>
            <v-card-title class="headline">
                {{ title }}
            </v-card-title>
            <v-card-text>{{ body }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="choose(false)">
                    {{ cancelButtonText }}
                </v-btn>
                <v-btn color="green darken-1" text @click="choose(true)">
                    {{ confirmButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: 'Confirm',
        },
        body: {
            type: String,
            required: false,
            default: 'Are you sure?',
        },
        confirmButtonText: {
            type: String,
            required: false,
            default: 'Yes',
        },
        cancelButtonText: {
            type: String,
            required: false,
            default: 'No',
        },
        // Opt-in width override; defaults to the original 290 so existing confirm dialogs are
        // unchanged. Pass a larger value for dialogs with longer body text or wide buttons.
        maxWidth: {
            type: [Number, String],
            required: false,
            default: 290,
        },
    },
    data() {
        return {
            value: false,
        }
    },
    mounted() {
        document.addEventListener('keyup', this.onEnterPressed)
    },
    destroyed() {
        document.removeEventListener('keyup', this.onEnterPressed)
    },
    methods: {
        onEnterPressed(e) {
            if (e.keyCode === 13) {
                e.stopPropagation()
                this.choose(true)
            }
        },
        choose(value) {
            this.$emit('result', value)
            this.value = value
            this.$destroy()
        },
        change() {
            this.$destroy()
        },
    },
}
</script>
